export const areaTypeParameterTypes = [
    {label: "String", name: "string"},
    {label: "Float", name: "float"},
    {label: "Integer", name: "integer"},
    {label: "Boolean", name: "boolean"},
]

